<template>
  <div v-if="getBalance[currency] && getCurrency[currency] && getSecure">
    <div class="title text-center">
      <div class="container lg">
        <span class="text-accent">{{ $t("Transfer") }}</span>
        <div class="left">
          <a v-on:click="$router.go(-1)">
            <i class="fad fa-arrow-left fa-back"></i
          ></a>
        </div>
      </div>
    </div>

    <div class="container-center lg animated fadeIn" v-if="camera == 'auto'">
      <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit"
        ><div class="loader-example" v-if="!ready">
          <div class="loader-bar"></div></div
      ></qrcode-stream>
      <div class="text-center m-t-sm">
        <qrcode-capture @decode="onDecode" v-if="error" />

        <a class="btn btn-link btn-block m-t-sm" v-on:click="turnCameraOff()"
          ><i class="fad fa-times-circle fa-2x"></i
        ></a>
      </div>
    </div>

    <div class="container-center lg animated fadeIn" v-if="camera == 'off'">
      <table class="table table-condensed">
        <thead>
          <tr>
            <th class="coin text-center" colspan="3">
              <div class="coin m-b-md">
                <img :src="require(`@/assets/tokens/${currency}.png`)" />
                - {{ getCurrency[currency].name }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $t("Totalbalance") }}</td>
            <td class="text-right font-bold">
              {{ getBalance[currency].balance }} {{ currency }}
            </td>
          </tr>
          <tr>
            <td>{{ $t("Inorder") }}</td>
            <td class="text-right font-bold">
              {{ getBalance[currency].inorder }} {{ currency }}
            </td>
          </tr>
          <tr>
            <td>{{ $t("Instaking") }}</td>
            <td class="text-right font-bold">
              {{ getBalance[currency].instaking }}
              {{ currency }}
            </td>
          </tr>
          <tr>
            <td>{{ $t("Availablebalance") }}</td>
            <td class="text-right font-bold pointer" v-on:click="withdrawAll">
              <span class="usage11 c-accent"
                >{{ getBalance[currency].available }} {{ currency }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>

      <div class="panel panel-filled">
        <div class="panel-body">
          <form @submit.prevent="submit" class="form-horizontal">
            <h5>Notice</h5>
            <ul>
              <li>Transfer with Email is free.</li>
            </ul>
            <div class="form-group">
              <label for="Currency" class="col-xs-4 control-label">{{
                $t("Currency")
              }}</label>
              <div class="col-xs-8">
                <select id="Currency" v-model="currency" class="form-control">
                  <option
                    class="coin"
                    v-for="c in getCurrency"
                    v-bind:key="c.id"
                    v-bind:value="c.coin"
                    >{{ c.coin }}</option
                  >
                </select>
              </div>
            </div>
            <div class="form-group">
              <label for="address" class="col-xs-4 control-label">{{
                $t("Email")
              }}</label>
              <div class="col-xs-8">
                <input
                  id="address"
                  type="text"
                  v-model="address"
                  class="form-control"
                  placeholder=""
                />
                <span
                  class="unit font-bold c-white pointer"
                  v-on:click="turnCameraOn()"
                >
                  <i class="fad fa-camera-retro"></i
                ></span>
              </div>
            </div>
            <div class="form-group">
              <label for="amount" class="col-xs-4 control-label">{{
                $t("Amount")
              }}</label>
              <div class="col-xs-8">
                <input
                  id="amount"
                  type="number"
                  v-model="amount"
                  class="form-control"
                  min="0"
                  step="0.00000001"
                />
                <span
                  class="unit text-accent font-bold pointer"
                  v-on:click="withdrawAll"
                  >MAX</span
                >
              </div>
            </div>
            <div class="form-group" v-if="getSecure.google_authen_active">
              <label for="factor" class="col-xs-4 control-label">2FA</label>
              <div class="col-xs-8">
                <input
                  id="factor"
                  type="text"
                  v-model="factor"
                  placeholder="Google Authentication Code"
                  class="form-control"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="col-xs-12 text-right">
                {{ $t("Fee") }}:
                <span class="c-white font-bold">0%</span>
                , {{ $t("Receive") }}:
                <span class="c-white font-bold" v-if="amount">{{
                  amount
                }}</span>
                <span class="c-white font-bold" v-else>--</span> {{ currency }}
              </div>
            </div>
            <button
              v-if="loading"
              class="btn btn-default btn-block"
              disabled=" "
            >
              <i class="fad fa-spinner-third fa-spin m-r-xs"></i
              >{{ $t("Loading") }}
            </button>
            <button
              v-else-if="!address || !amount"
              class="btn btn-default btn-block"
              disabled=" "
            >
              {{ $t("Transfer") }}
            </button>
            <button v-else class="btn btn-accent btn-block text-accent">
              {{ $t("Transfer") }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream, QrcodeCapture } from "vue-qrcode-reader";
import nativeToast from "native-toast";
import user from "@/api/user";
import { mapGetters } from "vuex";

export default {
  components: { QrcodeStream, QrcodeCapture },
  data() {
    return {
      camera: "off",
      error: "",
      currency: this.$route.params.currency || "BTC",
      address: this.$route.params.address || null,
      amount: this.$route.params.amount || null,
      factor: null,
      loading: false,
      ready: false
    };
  },
  computed: mapGetters(["getBalance", "getCurrency", "getSecure"]),
  methods: {
    async onInit(promise) {
      this.ready = false;

      try {
        await promise;
      } catch (error) {
        console.error(error);
      } finally {
        this.ready = true;
      }

      try {
        await promise;
      } catch (error) {
        if (error.name === "NotAllowedError") {
          this.error = "ERROR: you need to grant camera access permisson";
        } else if (error.name === "NotFoundError") {
          this.error = "ERROR: no camera on this device";
        } else if (error.name === "NotSupportedError") {
          this.error = "ERROR: secure context required (HTTPS, localhost)";
        } else if (error.name === "NotReadableError") {
          this.error = "ERROR: is the camera already in use?";
        } else if (error.name === "OverconstrainedError") {
          this.error = "ERROR: installed cameras are not suitable";
        } else if (error.name === "StreamApiNotSupportedError") {
          this.error = "ERROR: Stream API is not supported in this browser";
        }
      }
    },
    turnCameraOn() {
      this.camera = "auto";
    },
    turnCameraOff() {
      this.camera = "off";
    },
    async onDecode(content) {
      this.address = content;
      this.turnCameraOff();
    },
    async submit() {
      this.loading = true;
      await user
        .transfer({
          to: this.address,
          amount: this.amount,
          currency: this.currency,
          twofa: this.factor
        })
        .then(() => {
          this.loading = false;
          nativeToast({
            message: "Sent " + this.currency + " Successfully.",
            position: "top",
            timeout: 3000,
            type: "success"
          });
          this.amount = null;
        })
        .catch(error => {
          this.loading = false;
          nativeToast({
            message: error.response.data.error,
            position: "top",
            timeout: 3000,
            type: "error"
          });
        });
    },
    withdrawAll() {
      this.amount = this.getBalance[this.currency].available;
    }
  }
};
</script>

<style scoped>
input[type="file"] {
  display: inline-block;
  cursor: pointer;
  width: 300px;
  height: 50px;
  overflow: hidden;
  text-align: center;
}

input[type="file"]:before {
  width: 300px;
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  content: "Open Camera";
  display: inline-block;
  background: #1d1f24;
  border: 1px solid #949ba2;
  padding: 0 20px;
  text-align: center;
  border-radius: 10px;
}

input[type="file"]::-webkit-file-upload-button {
  visibility: hidden;
}
</style>
